import { useGetCourses } from '@agently/api';
import { courseStatus } from '@agently/types';

const Training = () => {
  const coursesQuery = useGetCourses({
    variables: {
      status: [courseStatus.IN_PROGRESS],
    },
  });
  const courses = coursesQuery.data;

  if (courses.length === 0) return null;
  return (
    <div className="rounded-full absolute top-0 right-3 bg-red-400 text-xs text-white size-4 grid place-content-center">
      {courses.length}
    </div>
  );
};

export default Training;
